// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1li_z","content":"styles_content__14dLq","checkbox":"styles_checkbox__29F-A","checkboxLabel":"styles_checkboxLabel__3TqMQ"};